import React from 'react';
import {IRegulationComponents} from "./regulation-components.interface";
import {
    HeaderWelcomeLoginButtonComponentProps
} from "../../components/header/buttons/login-button/header-login-button.component.props";
import {
    HeaderWelcomeRegisterButtonComponentProps
} from "../../components/header/buttons/register-button/header-register-button.component.props";
import {
    HeaderLoginButtonComponent
} from "../../components/header/buttons/login-button/header-login-button.component";
import {IServiceFactoryExtended} from "../service-factory-extended.interface";
import {
    HeaderRegisterButtonComponent
} from "../../components/header/buttons/register-button/header-register-button.component";
import {AboutComponent, AboutComponentProps} from "../../components/about-component/about.component";
import {MinimumGamblingAgeComponent} from "../../components/responsible-gambling/minimum-gambling-age/minimum-gambling-age.component";

export class RegulationComponentsCommon implements IRegulationComponents {
    constructor(protected readonly services: IServiceFactoryExtended) {
    }

    renderHeaderLoginButton(props: HeaderWelcomeLoginButtonComponentProps): React.ReactElement {
        return (
            <HeaderLoginButtonComponent {...props}/>
        );
    }

    renderHeaderRegisterButton(props: HeaderWelcomeRegisterButtonComponentProps): React.ReactElement {
        return (
            <HeaderRegisterButtonComponent {...props}/>
        );
    }

    renderHeaderRegulationIcons() {
        return null;
    }

    renderHeaderMinimumGamblingAge() {
        return(<MinimumGamblingAgeComponent/>);
    }

    protected _getAboutDialogProps(): Promise<AboutComponentProps> {
        return Promise.resolve({});
    }

    showAboutDialog(): Promise<void> {
        return this._getAboutDialogProps().then(props => {
            return new Promise<void>(resolve => {
                this.services.dialog.showModal(dialogHandler => <AboutComponent
                    {...props}
                    clientVersion={this.services.sdk.getSkin().getVersion()}
                    dialogHandler={dialogHandler}
                />, {
                    title: this.services.translation.translate("ABOUT_TITLE"),
                    forceTransparentBackground: true,
                    disableFullscreenMobile: true,
                    forceCentralization: true,
                    mobileCenterHeader: true,
                    onClosed: () => resolve()
                });
            })
        })


    }

}